import React from 'react';
import cn from 'classnames';

import WidgetTitle from 'components/widget/WidgetTitle.component';
import WEEKDAY_TAG from 'constants/time/weekdayTag.const';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import { withTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import call from 'utils/functions/call.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import asObject from 'utils/objects/asObject.util';
import isMissing from 'utils/predicates/any/isMissing.util';

import CN from './Workdays.module.scss';

const Workdays = ({ name: nameFromProps, tag: tagFromProps, onChange = alwaysNoop, isDarkMode }) => {
  const tag = fromAnyToTrimmed(tagFromProps);
  const name = fromAnyToTrimmed(nameFromProps);

  const [selected, setSelected] = useStateWhileMounted({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
  });

  return (
    <div data-bem="Workdays" data-tag={tag} data-name={name}>
      <WidgetTitle tag="Workdays__title">Repeat every week on:</WidgetTitle>

      <div data-bem="Workdays" data-tag={tag} className={CN.list}>
        {Object.entries(WEEKDAY_TAG).map(([key, description]) => {
          const isSelected = fromAnyToBool(selected[key]);

          const handleClick = () => {
            const raw = { ...selected, [key]: !isSelected };

            const { value } = asObject(call(`Workdays.onChange`, onChange, { name, tag, raw }));

            setSelected(isMissing(value) ? raw : value);
          };

          return (
            <div
              data-bem="Workdays__item"
              key={key}
              data-key={key}
              className={cn({
                [CN.button]: true,
                [CN.selected]: isSelected,
                [CN.darkMode]: isDarkMode,
              })}
              onClick={handleClick}
              role="button"
              tabIndex={0}
            >
              {description}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const WorkdaysHoc = withTheme()(Workdays);

export default WorkdaysHoc;
